import TungstenOutlinedIcon from "@mui/icons-material/TungstenOutlined";
import { Typography } from "@mui/material";
import "./LawnSizeToolTip.css";
const LawnSizeToolTip = ({ content }: { content: string }) => {
  if (!content) {
    return null;
  }
  return (
    <div className="lawn-size-tooltip">
      <TungstenOutlinedIcon className="lawn-icon-container" />
      <Typography
        variant="body1"
        dangerouslySetInnerHTML={{
          __html:
            content ||
            "<strong>TIP:</strong> To remove a lawn area from your selection, simply tap it on the map.",
        }}
      />
    </div>
  );
};

export default LawnSizeToolTip;
